<template>
  <div id="results-caracteristics">
    <div v-if="showContents">
      <div class="action-bar">
        <btn type="primary" @click="exportPDF" size="sm">
          <div class="glyphicon glyphicon-download-alt"
                aria-hidden="true">
          </div>
          Exporter en PDF
        </btn>
      </div>
      <div v-for="c in caracteristics" :key="c.key">
        <h3 role="button" @click="toggle(c.key)">
          <span class="glyphicon glyphicon-plus" v-if="!showContents[c.key]"
                aria-hidden="true">
          </span>
          <span class="glyphicon glyphicon-minus" v-else
                aria-hidden="true">
          </span>

          {{c.title}}
        </h3>
        <collapse v-model="showContents[c.key]">
          <div class="row">
            <div class="col-xs-12 col-lg-10">
              <table class="table table-responsive module-table">
                <tbody>
                  <tr v-for="p in c.lines"
                      :key="`${c.key}-${p.key}`">
                    <td :colspan="p.heading ? 2 : 1"
                        :class="{ 'line-title' : !p.heading }">
                      <span v-if="p.heading">
                        <strong><i>{{ p.title }}</i></strong>
                      </span>
                      <span v-else v-html="p.title"></span>
                    </td>
                    <td v-if="!p.heading">
                      <div class="stat-container">
                        <h5 class="visible-xs hidden-sm">
                          <span>{{ p.title }}</span>
                        </h5>
                        <table class="table-responsive stat-table">
                          <tbody>
                            <tr v-for="(v, k) in p.values"
                                :key="`${p.key}-${k}`">
                              <td class="stat-label">{{ v.label }}</td>
                              <td class="stat-value">{{ v.count }}</td>
                              <td class="stat-percent">{{ v.percentage }}</td>
                            </tr>
                          </tbody>
                        </table>
                        <div class="icon-container" v-if="Object.keys(p.plot).length > 0">
                          <div class="text-center">
                            <a v-for="t in Object.keys(p.plot)"
                               role="button"
                               v-tooltip.unenterable="tooltips[t]"
                               :key="`${c.key}-${p.key}-${t}`"
                               @click="showChart(p, t)">
                              <svg-icon :icon="t" color="#fff"/>
                            </a>
                          </div>
                          <div v-if="focus === p" class="plot-container">
                            <chart
                              :type="`${plot.type}-chart`"
                              :config="plot.config"
                              :plugins="plot.plugins"
                              :exportConfig="plot.exportConfig">
                            </chart>
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </collapse>
      </div>
    </div>
    <div v-else>
      <alert type="warning">
        <slot name="default"></slot>
      </alert>
    </div>
  </div>
</template>
<script>
import svgIcon from '@/sui/components/svgIcon'
import chart from '@/sui/components/charts/chart'
import impl from '@/sui/components/results/impl/caracteristics'

export default {
  name: 'result-caracteristics',

  props: {
    caracteristics: {
      type: Array,
      default: null
    },

    title: {
      type: String,
      required: true
    },

    subtitle: {
      type: String,
      default: ''
    }
  },

  components: {
    'chart': chart,
    'svg-icon': svgIcon
  },

  data: function () {
    const showContents = {}
    if (this.caracteristics != null && this.caracteristics.length > 0) {
      this.caracteristics.forEach(
        (c, i) => {
          showContents[c.key] = !!c.open
        }
      )
    }

    return {
      showContents: showContents,
      focus: null,
      plotType: null,
      tooltips: {
        doughnut: 'Diagramme circulaire',
        bar: 'Diagramme en barres',
        boxplot: 'Boîte à moustache',
        violin: 'Diagramme en violon'
      }
    }
  },

  watch: {
    title: function (t) {
      if (t != null) {
        const showContents = {}
        if (this.caracteristics != null && this.caracteristics.length > 0) {
          this.caracteristics.forEach(
            (c, i) => {
              showContents[c.key] = !!c.open
            }
          )
        }
        this.showContents = showContents
      }
    },

    caracteristics: function (n) {
      if (n != null && n.length > 0) {
        const showContents = {}
        const vm = this
        n.forEach(
          (c, i) => {
            const sc = vm.showContents[c.key]
            if (sc != null) {
              showContents[c.key] = sc
            } else {
              showContents[c.key] = !!c.open
            }
          }
        )
        this.showContents = showContents
      }
    }
  },

  computed: {
    plot: function () {
      if (this.focus == null || this.plotType == null) {
        return null
      }
      const p = this.focus.plot[this.plotType]()
      return {
        type: this.plotType,
        config: p.config,
        plugins: p.plugins,
        exportConfig: p.exportConfig
      }
    }
  },

  methods: {

    toggle: function (k) {
      this.showContents[k] = !this.showContents[k]
    },

    showChart: function (v, t) {
      if (this.focus === v && this.plotType === t) {
        this.focus = null
        this.plotType = null
        return
      }

      this.focus = v
      this.plotType = t
    },

    exportPDF: function () {
      impl.exportPDF(this.caracteristics, this.title, this.subtitle)
    }
  }
}
</script>
<style scoped lang="less">
@import '~variables';
h3 .glyphicon {
  margin-right: 0.3rem;
  font-size: 70%;
  color: @base;
  opacity: 0.7;
}

.stat-value {
  text-align: right;
  font-weight: bold;
  width: 5rem;
}

.stat-percent {
  text-align: right;
  width: 5rem;
}

.stat-value {
  width: 5rem;
}

.stat-label {
  max-width: 22rem;
}

.stat-table {
  width: 100%;
}

.stat-container {
  width: 40rem;
  float: right;

  .icon-container {
    width: 100%;
    background-color: lighten(@base, 40%);
    padding-top: 0.4rem;
    border-radius: 0.2rem;
  }

  .chart-data-container {
    background-color: white;
  }

  .plot-container {
    width: 100%;
  }

  a {
    padding: 0.0rem;
    width: 3rem;
    display: inline-block;
    border-radius: 50%;
    background-color: @base;
    margin: 0rem 0.2rem;

    :hover {
      background-color: @dark-base;
      border-radius: 50%;
    }
  }
}

@media (min-width: 0) and (max-width: @screen-xs-max) {
  .table-responsive {
    border: 0px;
  }

  .line-title {
    display: none;
  }

  .stat-container {
    width: 90vw;
    margin-left: auto;
    margin-right: auto;
    float: none;
  }

  .icon-container {
    max-width: 100%;
  }
}

.alert h3 {
  margin-top: 0rem;
}

.action-bar {
  margin-top: 0.2rem;
  .glyphicon {
    margin-right: 0.4rem;
  }
}

#results-caracteristics {
  min-height: 90rem;
}
</style>
